export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.bd1f9919.jpg";